module.exports = __webpack_public_path__ + "static/media/rubik-v9-latin-300.239cf859.woff2";